/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Group from 'material/group/group';
import Link from 'material/ctas/link/link_container';
import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/contentanalyticscard/story/story_styles';



/* ========== ~~~~~~~~~~ CONTENTANALYTICSCARD : STORY : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const StoryContentAnalyticsCard = (props) => (
    <Group name={`content ${props.classes.storyanalyticscard}`}>
        <div className={`title-container`}>
            {props.contentDetail.backgroundImageURL && <div className={`image`} style={{ backgroundImage: `url(${props.contentDetail.backgroundImageURL})` }} />}
            <div className={`title`}> {props.contentDetail.title} </div>
        </div>
        <Link type={`action`} klass={`clicks`} action={() => props.moveToDetailedViewAnalytics(props.contentDetail.contentUUID)}>
            <div className={`title`}>Clicks:</div>
            <div className={`count-container`}>
                <div className={`count`}> {props.contentDetail.clicks}</div>
                <div className={'analytics-link'}>
                    See detailed analytics <Icon name={`chart-line`} />
                </div>
            </div>
        </Link>
    </Group>
);



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(StoryContentAnalyticsCard);